import { AbstractModel, DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class RandomScreeningYearlyProgress extends AbstractModel {
  @autoserialize
  eligibleDrivers: number;

  @autoserialize
  estimateAnnualDrugTests: number;

  @autoserialize
  estimateAnnualAlcoholTests: number;

  @autoserialize
  drugTestsCompletedToDate: number;

  @autoserialize
  alcoholTestsCompletedToDate: number;

  @autoserializeAs(Date)
  periodStartDate: Date;

  @autoserializeAs(Date)
  periodEndDate: Date;

  static OnSerialized(instance: RandomScreeningYearlyProgress, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.periodStartDate)) {
      json.periodStartDate = DateUtil.serializeInstant(instance.periodStartDate);
    }

    if (!isNullOrUndefined(instance.periodEndDate)) {
      json.periodEndDate = DateUtil.serializeInstant(instance.periodEndDate);
    }
  }

  static OnDeserialized(instance: RandomScreeningYearlyProgress, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['periodStartDate'])) {
      instance.periodStartDate = DateUtil.deserializeInstant(json['periodStartDate']);
    }

    if (!isNullOrUndefined(json['periodEndDate'])) {
      instance.periodEndDate = DateUtil.deserializeInstant(json['periodEndDate']);
    }
  }
}
